// כתובות השרת
// בפיתוח: ריק (הפרוקסי מ-package.json מטפל)
// בפרודקשן: REACT_APP_API_URL מ-.env.production
const API_URL = process.env.REACT_APP_API_URL || '';
const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:4455';

// הרשמה עצמית לאתר. סגורה כרגע, פתיחה מחדש: REACT_APP_REGISTRATION_OPEN=true
// (יש לפתוח גם בשרת: REGISTRATION_OPEN=true)
const REGISTRATION_OPEN = process.env.REACT_APP_REGISTRATION_OPEN === 'true';
const CONTACT_EMAIL = 'cs@clickerim.co.il';

export { API_URL, WS_URL, REGISTRATION_OPEN, CONTACT_EMAIL };
